/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrloadfailed3Inputs */

const en_checkinqrloadfailed3 = /** @type {(inputs: Checkinqrloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The check-in code could not be loaded.`)
};

const de_checkinqrloadfailed3 = /** @type {(inputs: Checkinqrloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Check-in-Code konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The check-in code could not be loaded." |
*
* @param {Checkinqrloadfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrloadfailed3 = /** @type {((inputs?: Checkinqrloadfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrloadfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrloadfailed3(inputs)
	return de_checkinqrloadfailed3(inputs)
});
export { checkinqrloadfailed3 as "checkinQrLoadFailed" }